import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { UserNextLevelRequest } from '../../../types/user'
import { useApiPostMutation } from '../useApi'

export const useUserNextLevel = () => {
  const queryClient = useQueryClient()
  const mutation = useApiPostMutation<ApiResponse, UserNextLevelRequest>()

  return {
    mutateAsync: async (data: UserNextLevelRequest) => {
      const result = await mutation.mutateAsync({
        url: '/user/nextLevel',
        data,
      })

      queryClient.invalidateQueries({ queryKey: ['user'] })
      queryClient.invalidateQueries({ queryKey: ['userQuestion'] })

      return result
    },
  }
}
